<template>
  <div class="v-table">
    <v-server-table
      :ref="tableRef"
      :url="url"
      :name="name"
      :columns="tableColumns"
      :options="tableOptions"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import { ServerTable } from 'vue-tables-2';

import profileAdminActions from '@/components/_vue/_table_templates/ProfileAdminActions.vue';
import miniThumb from '@/components/_vue/_table_templates/MiniThumb.vue';

Vue.use(ServerTable, {}, true, 'bootstrap4', require('@/components/_vue/vue-tables-2-templates/ns-table-template-switch.js'));

export default {
  props: ['options', 'submission'],
  data() {
    return {};
  },
  computed: {
    url() {
      return this.options.url;
    },

    tableRef() {
      return this.options.name;
    },

    name() {
      return this.options.name;
    },

    tableColumns() {
      return this.options.columns;
    },

    tableOptions() {
      const headings = {};
      const texts = {
        count: 'Showing {from} to {to} of {count} users|{count} users|One user',
        limit: 'Users:',
      };
      let options = {
        headings,
        texts,
        filterable: false,
        footerHeadings: false,
        orderBy: {
          column: 'id',
          ascending: false,
        },
        pagination: {
          chunk: 10,
          dropdown: false,
        },

        perPage: 10,
        perPageValues: [10, 50, 100],
        skin: 'table table-bordered',
        // templates: this.templates,

        templates: {
          actions: profileAdminActions,
          thumb: miniThumb,
        },
      };

      if (this.options.tableOptions) {
        options = Object.assign(options, this.options.tableOptions);
      }

      return options;
    },
  },

  created() {
    this.$store.state.pageOptions = this.options;
  },

  mounted() {
    Bus.$on('refresh', () => {
      this.$refs[this.name].getData();
    });
  },

  beforeDestroy() {
    Bus.$off('refresh');
  },
};
</script>
<style>
.v-table .table-responsive {
  padding-bottom: 150px;
}
</style>
